module.exports = __webpack_public_path__ + "static/media/history-disabled.21815dec.svg";